export const COMPANY_PROFILE_LIST_LEFT = [
    "Global Buyer/Supplier Lists API",
    "Company Matcher API",
    "Global Buyer/Supplier Profile API",
]

export const COMPANY_PROFILE_LIST_RIGHT = [
    "Global Trade Shipments API",
    "Landed Cost API",
    "Sanctions Screener API",
]

export const LOCALSTORAGE_KEYS = {
    USER_DETAILS: 'user_details',
    USER_DATA: 'user_data',
    USER_TRACK: 'userTrackingDetails'
}

export const ENVIROMENT = {
    DEVELOPMENT: 'development',
    PRODUCTION: 'production',
}

export const DEFAULT_TIMER = 60

export const HTTP_REQUEST_TYPE = {
    post: 'http_request_post',
    get: 'http_request_get'
}

export const DATA_TYPE_HANDLER = {
    object: {
        label: '{ }',
        class: 'data_type_object'
    },
    string: {
        label: 'abc',
        class: 'data_type_string'
    },
    boolean: {
        label: '0/1',
        class: 'data_type_boolean'
    },
    number: {
        label: '123',
        class: 'data_type_number'
    },
    array: {
        label: '[ ]',
        class: 'data_type_array'
    },
    date: {
        label: 'YYYY-MM-DD',
        class: 'data_type_date'
    }
}

export const DATA_TYPE = {
    object: 'object',
    number: 'number',
    date: 'date',
    string: 'string',
    boolean: 'boolean',
    array: 'array'
}

export const DUMMY_DATA = {
    "current_credits": 15,
    "maximum_credits": 25,
    "data":
        [
            {
                "api_product_name": "Global trade data",
                "sub_data": [
                    {
                        "api_name": "Global buyer/supplier list api",
                        "api_endpoint": "{base_url}/v1/global_buyer_supplier_list",
                        "type": "POST",
                        "credit_rate": "2 credits/ 5 (buyer/supplier)",
                        "request_params": {
                            "list_abbreviations": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "entity_name": {
                                "type": "string"
                            },
                            "address_details": {
                                "type": "array",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "city": {
                                            "type": "string"
                                        },
                                        "state": {
                                            "type": "string"
                                        },
                                        "street": {
                                            "type": "string"
                                        },
                                        "country": {
                                            "type": "string"
                                        }
                                    }
                                }
                            },
                            "address_details_value": {
                                "type": "object",
                                "properties": {
                                    "city": {
                                        "type": "string"
                                    },
                                    "citizenship": {
                                        "type": "array",
                                        "items": {
                                            "type": "string"
                                        }
                                    }
                                }
                            },
                            "shipper_id": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "shipperName": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "consigneeName": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "isSortable": {
                                "type": "boolean"
                            },
                            "pageNumber": {
                                "type": "number"
                            }
                        },
                        "response_body": {
                            "totalCompanies": {
                                "type": "integer",
                                "description": "This attribute represents the total number of companies matching the request criteria"
                            },
                            "companies": {
                                "type": "array",
                                "description": "This attribute will contain a list of companies that match the search criteria",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "companyId": {
                                            "type": "string",
                                            "description": "This attribute is the Trademo unique identifier of a company which could be utilized with Trademo’s other APIs"
                                        },
                                        "companyName": {
                                            "type": "string",
                                            "description": "This attribute contains the name of the company"
                                        },
                                        "country": {
                                            "type": "string",
                                            "description": "This attribute contains the domicile country of the company"
                                        },
                                        "state": {
                                            "type": "string",
                                            "description": "This attribute contains the domicile state of the company wherever available"
                                        },
                                        "city": {
                                            "type": "string",
                                            "description": "This attribute contains the domicile city of the company wherever available"
                                        },
                                        "zipCode": {
                                            "type": "string",
                                            "description": "This attribute contains the domicile zip code of the company wherever available"
                                        },
                                        "addressList": {
                                            "type": "string",
                                            "description": "This attribute contains the list of addresses of the company wherever available"
                                        },
                                        "stockTickers": {
                                            "type": "array",
                                            "description": "A list of stock tickers of the company if the company is listed",
                                            "items": {
                                                "type": "object",
                                                "properties": {
                                                    "exchangeName": {
                                                        "type": "string",
                                                        "description": "This attribute specifies the stock exchange where the company's stock is listed"
                                                    },
                                                    "ticker": {
                                                        "type": "string",
                                                        "description": "The ticker name of the stock in the particular stock exchange"
                                                    }
                                                }
                                            }
                                        },
                                        "matchedCountriesTradingWith": {
                                            "type": "array",
                                            "description": "This attribute specifies the list of matches found for the company with the 'countriesTradingWithList' request parameter",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "numberOfShipments": {
                                            "type": "integer",
                                            "description": "This attribute specifies the relevant number of shipments as per the search criteria"
                                        },
                                        "shipmentValue": {
                                            "type": "integer",
                                            "description": "This attribute specifies the relevant shipment value as per the search criteria"
                                        },
                                        "matchedProductKeyword": {
                                            "type": "array",
                                            "description": "This attribute specifies the top 10 list of matches found for the company with the 'productKeywords' request parameter",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "matchedHSCodes": {
                                            "type": "array",
                                            "description": "This attribute specifies the top 10 list of matches found for the company with the 'HS Codes' request parameter",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "tradingPartnerCount": {
                                            "type": "integer",
                                            "description": "This attribute specifies the relevant tradingPartnerCount as per the search criteria"
                                        }
                                    }
                                }
                            }
                        }
                    },
                    {
                        "api_name": "Company Matcher API",
                        "api_endpoint": "{base_url}/v1/company_matcher_api",
                        "type": "POST",
                        "credit_rate": "0 credits",
                        "request_params": {
                            "list_abbreviations": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "entity_name": {
                                "type": "string"
                            },
                            "address_details": {
                                "type": "array",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "city": {
                                            "type": "string"
                                        },
                                        "state": {
                                            "type": "string"
                                        },
                                        "street": {
                                            "type": "string"
                                        },
                                        "country": {
                                            "type": "string"
                                        }
                                    }
                                }
                            },
                            "address_details_value": {
                                "type": "array",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "city": {
                                            "type": "string"
                                        },
                                        "state": {
                                            "type": "string"
                                        },
                                        "street": {
                                            "type": "string"
                                        },
                                        "country": {
                                            "type": "string"
                                        }
                                    }
                                }
                            },
                            "address_details_value": {
                                "type": "object",
                                "properties": {
                                    "city": {
                                        "type": "string"
                                    },
                                    "citizenship": {
                                        "type": "array",
                                        "items": {
                                            "type": "string"
                                        }
                                    }
                                }
                            },
                            "shipper_id": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "shipperName": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "consigneeName": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "isSortable": {
                                "type": "boolean"
                            },
                            "pageNumber": {
                                "type": "number"
                            }
                        },
                        "response_body": {
                            "totalCompaniesCount": {
                                "Type": "integer",
                                "Description": "Count of all matched companies",
                                "Required": true
                            },
                            "companies": {
                                "type": "array",
                                "description": "This attribute will contain a list of companies that match the search criteria",
                                "required": true,
                                "items": {
                                    "companyId": {
                                        "type": "string",
                                        "description": "This attribute is the unique identifier of the organization which will be utilized in future APIs"
                                    },
                                    "companyName": {
                                        "type": "string",
                                        "description": "This attribute contains the name of the company."
                                    },
                                    "country": {
                                        "type": "string",
                                        "description": "This attribute contains the country of the company"
                                    },
                                    "nameMatchPercentage": {
                                        "type": "integer",
                                        "description": "This attribute defines the match percentage of the company to the searched company name."
                                    }
                                }
                            }
                        }
                    },
                    {
                        "api_name": "Global Buyer/Supplier Profile API",
                        "api_endpoint": "{base_url}/v1/global_buyer_supplier_company_profile",
                        "type": "POST",
                        "credit_rate": "2 credits/ 5 (buyer/supplier)",
                        "request_params": {
                            "list_abbreviations": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "entity_name": {
                                "type": "string"
                            },
                            "address_details": {
                                "type": "array",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "city": {
                                            "type": "string"
                                        },
                                        "state": {
                                            "type": "string"
                                        },
                                        "street": {
                                            "type": "string"
                                        },
                                        "country": {
                                            "type": "string"
                                        }
                                    }
                                }
                            },
                            "address_details_value": {
                                "type": "object",
                                "properties": {
                                    "city": {
                                        "type": "string"
                                    },
                                    "citizenship": {
                                        "type": "array",
                                        "items": {
                                            "type": "string"
                                        }
                                    }
                                }
                            },
                            "shipper_id": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "shipperName": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "consigneeName": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "isSortable": {
                                "type": "boolean"
                            },
                            "pageNumber": {
                                "type": "number"
                            }
                        },
                        "response_body": {
                            "companyID": {
                                "type": "string",
                                "required": true,
                                "description": "This attribute is the Trademo unique identifier of a company which could be utilized in other Trademo APIs."
                            },
                            "companyName": {
                                "type": "string",
                                "required": true,
                                "description": "This contains the name of the company."
                            },
                            "country": {
                                "type": "string",
                                "required": true,
                                "description": "This contains the country of the company."
                            },
                            "state": {
                                "type": "string",
                                "required": false,
                                "description": "This contains the state of the company."
                            },
                            "imported6DigitHsCodes": {
                                "type": "array",
                                "description": "A list of 6-digit HS Codes which the company is importing.",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "hscode": {
                                            "type": "string",
                                            "required": true,
                                            "description": "The HS Code identifier."
                                        },
                                        "percentageShare": {
                                            "type": "float",
                                            "description": "Percentage Share of the respective HS code in the company's imports."
                                        }
                                    }
                                }
                            },
                            "exported6DigitHsCodes": {
                                "type": "array",
                                "description": "A list of 6-digit HS Codes which the company is exporting.",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "hscode": {
                                            "type": "string",
                                            "required": true,
                                            "description": "The HS Code identifier."
                                        },
                                        "percentageShare": {
                                            "type": "float",
                                            "description": "Percentage Share of the respective HS code in the company's exports."
                                        }
                                    }
                                }
                            },
                            "importedProductKeywords": {
                                "type": "array",
                                "description": "A list of product keywords which the company is importing.",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "productKeyword": {
                                            "type": "string",
                                            "required": true,
                                            "description": "The product keyword identifier."
                                        },
                                        "percentageShare": {
                                            "type": "float",
                                            "description": "Percentage Share of the respective product keyword in the company's imports."
                                        }
                                    }
                                }
                            },
                            "exportedProductKeywords": {
                                "type": "array",
                                "description": "A list of product keywords which the company is exporting.",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "productKeyword": {
                                            "type": "string",
                                            "required": true,
                                            "description": "The product keyword identifier."
                                        },
                                        "percentageShare": {
                                            "type": "float",
                                            "description": "Percentage Share of the respective product keyword in the company's exports."
                                        }
                                    }
                                }
                            },
                            "stockTickers": {
                                "type": "array",
                                "description": "A list of stocker tickers of the company.",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "exchangeName": {
                                            "type": "string",
                                            "required": true,
                                            "description": "The stock exchange where the company's stock is listed."
                                        },
                                        "ticker": {
                                            "type": "string",
                                            "required": true,
                                            "description": "The ticker name of the stock in a particular stock exchange."
                                        }
                                    }
                                }
                            },
                            "countriesImportingFrom": {
                                "type": "array",
                                "description": "A list of countries from which the company is importing.",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "country": {
                                            "type": "string",
                                            "required": true,
                                            "description": "The name of the country."
                                        },
                                        "percentageShare": {
                                            "type": "float",
                                            "description": "Percentage Share of the respective company in the company's imports."
                                        }
                                    }
                                }
                            },
                            "countriesExportingTo": {
                                "type": "array",
                                "description": "A list of countries to which the company is exporting.",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "country": {
                                            "type": "string",
                                            "required": true,
                                            "description": "The name of the country."
                                        },
                                        "percentageShare": {
                                            "type": "float",
                                            "description": "Percentage Share of the respective company in the company's exports."
                                        }
                                    }
                                }
                            },
                            "portsOfLading": {
                                "type": "array",
                                "description": "A list of ports of lading from which the company is exporting.",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "port": {
                                            "type": "string",
                                            "required": true,
                                            "description": "The name of the port."
                                        },
                                        "percentageShare": {
                                            "type": "float",
                                            "description": "Percentage Share of the respective company in the company's exports."
                                        }
                                    }
                                }
                            },
                            "portsOfUnlading": {
                                "type": "array",
                                "description": "A list of ports of unlading from which the company is exporting.",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "port": {
                                            "type": "string",
                                            "required": true,
                                            "description": "The name of the port."
                                        },
                                        "percentageShare": {
                                            "type": "float",
                                            "description": "Percentage Share of the respective company in the company's exports."
                                        }
                                    }
                                }
                            },
                            "importTradingPartnerCount": {
                                "type": "integer",
                                "description": "This contains the number of trading partners from which the company is importing."
                            },
                            "importTradingPartners": {
                                "type": "array",
                                "description": "This contains the list of import trading partners of the company.",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "companyName": {
                                            "type": "string",
                                            "required": true,
                                            "description": "This contains the name of the trading partner."
                                        },
                                        "companyID": {
                                            "type": "string",
                                            "required": true,
                                            "description": "This attribute is the Trademo unique identifier of the trading partner, which can further be used to fetch the trading partner's company profile."
                                        },
                                        "country": {
                                            "type": "string",
                                            "description": "This contains the country of the trading partner."
                                        },
                                        "percentageShare": {
                                            "type": "float",
                                            "description": "Percentage Share of the respective company in the company's imports."
                                        }
                                    }
                                }
                            },
                            "exportTradingPartnerCount": {
                                "type": "integer",
                                "description": "This contains the number of trading partners to which the company is exporting."
                            },
                            "exportTradingPartners": {
                                "type": "array",
                                "description": "This contains the list of export trading partners of the company.",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "companyName": {
                                            "type": "string",
                                            "required": true,
                                            "description": "This contains the name of the trading partner."
                                        },
                                        "companyID": {
                                            "type": "string",
                                            "required": true,
                                            "description": "This attribute is the Trademo unique identifier of the trading partner, which can further be used to fetch the trading partner's company profile."
                                        },
                                        "country": {
                                            "type": "string",
                                            "description": "This contains the country of the trading partner."
                                        },
                                        "percentageShare": {
                                            "type": "float",
                                            "description": "Percentage Share of the respective company in the company's exports."
                                        }
                                    }
                                }
                            },
                            "totalShipmentsImportedCount": {
                                "type": "float",
                                "description": "This field contains the count of shipments imported by the company as per the trade time period in the request."
                            },
                            "totalShipmentsExportedCount": {
                                "type": "float",
                                "description": "This field contains the count of shipments exported by the company as per the trade time period in the request."
                            },
                            "totalShipmentsImportedWeight": {
                                "type": "float",
                                "description": "This field contains the weight of shipments imported by the company as per the trade time period in the request."
                            },
                            "totalShipmentsExportedWeight": {
                                "type": "float",
                                "description": "This field contains the weight of shipments exported by the company as per the trade time period in the request."
                            },
                            "averageWeightPerImportShipment": {
                                "type": "float",
                                "description": "This field contains the average weight of shipments imported by the company as per the trade time period in the request."
                            },
                            "averageWeightPerExportShipment": {
                                "type": "float",
                                "description": "This field contains the average weight of shipments exported by the company as per the trade time period in the request."
                            },
                            "averageWeightImportedPerMonth": {
                                "type": "float",
                                "description": "This field contains the average weight of shipments per month of shipments imported by the company as per the trade time period in the request."
                            },
                            "averageWeightExportedPerMonth": {
                                "type": "float",
                                "description": "This field contains the average weight of shipments exported by the company as per the trade time period in the request."
                            }
                        }
                    },
                    {
                        "api_name": "Global Trade Shipments API ",
                        "api_endpoint": "{base_url}/v1/shipment_search_api",
                        "type": "POST",
                        "credit_rate": "1 credits/ 10 (shipments)",
                        "request_params": {
                            "shipperName": {
                                "type": "array",
                                "description": "Name of the shipper company",
                                "items": {
                                    "type": "string"
                                },
                                "required": false
                            },
                            "shipperId": {
                                "type": "string",
                                "description": "Specifies the Trademo's company ID for the company exporting the shipment",
                                "required": false
                            },
                            "consigneeName": {
                                "type": "array",
                                "description": "Name of the consignee company",
                                "items": {
                                    "type": "string"
                                },
                                "required": false
                            },
                            "consigneeId": {
                                "type": "string",
                                "description": "Specifies the Trademo's company ID for the company importing the shipment",
                                "required": false
                            },
                            "shipperCountryName": {
                                "type": "array",
                                "description": "Domicile Countries of the Shipper. The list of countries would be provided in a separate document.",
                                "items": {
                                    "type": "string"
                                },
                                "required": false
                            },
                            "consigneeCountryName": {
                                "type": "array",
                                "description": "Domicile Countries of the Consignee. The list of countries would be provided in a separate document.",
                                "items": {
                                    "type": "string"
                                },
                                "required": false
                            },
                            "portOfLading": {
                                "type": "array",
                                "description": "With the help of this field user can filter out the shipments on the basis of Port of Lading.",
                                "items": {
                                    "type": "string"
                                },
                                "required": false
                            },
                            "portOfUnlading": {
                                "type": "array",
                                "description": "With the help of this field user can filter out the shipments on the basis of Port of Unlading.",
                                "items": {
                                    "type": "string"
                                },
                                "required": false
                            },
                            "productKeywords": {
                                "type": "array",
                                "description": "A list of product keywords to find the shipments related to these products based on semantic search.",
                                "items": {
                                    "type": "string"
                                },
                                "required": false
                            },
                            "hsCodes": {
                                "type": "array",
                                "description": "A list of 2, 4, 6, 8 or 10-digit HS Codes to find the shipments related to these HS Codes.",
                                "items": {
                                    "type": "string"
                                },
                                "required": false
                            },
                            "tradeTimePeriod": {
                                "type": "object",
                                "description": "This specifies the timeframe for which the trade for the shipments needs to be evaluated.",
                                "properties": {
                                    "fromDate": {
                                        "type": "date",
                                        "description": "Specifies the starting date for the time period for which the data needs to be queried"
                                    },
                                    "toDate": {
                                        "type": "date",
                                        "description": "Specifies the end date for the time period for which the data needs to be queried"
                                    }
                                },
                                "required": false
                            },
                            "shipmentWeightRange": {
                                "type": "object",
                                "description": "Specifies the weight (kgs) range of the shipments required.",
                                "properties": {
                                    "minimumValue": {
                                        "type": "integer",
                                        "description": "Specifies the min shipment weight (kgs) of the required shipments."
                                    },
                                    "maximumValue": {
                                        "type": "integer",
                                        "description": "Specifies the max shipment weight (kgs) of the required shipments."
                                    }
                                },
                                "required": false
                            },
                            "shipmentValueRange": {
                                "type": "object",
                                "description": "Specifies the individual shipment value (USD) range of the shipments required.",
                                "properties": {
                                    "minimumValue": {
                                        "type": "integer",
                                        "description": "Specifies the min individual shipment value (USD) of the required shipments."
                                    },
                                    "maximumValue": {
                                        "type": "integer",
                                        "description": "Specifies the max individual shipment value (USD) of the required shipments."
                                    }
                                },
                                "required": false
                            },
                            "pageSize": {
                                "type": "integer",
                                "description": "This defines the number of shipments per page. It has to be in multiples of 5. The maximum page size could be 100.",
                                "required": false
                            },
                            "pageNumber": {
                                "type": "integer",
                                "description": "The page number of the search results to be returned. The maximum value depends on the number of items in the search criterion and the pageSize.",
                                "required": true
                            },
                            "sort": {
                                "type": "object",
                                "description": "Determines the sort criteria of the response list.",
                                "properties": {
                                    "field": {
                                        "type": "string",
                                        "description": "The field on which the sorting is to be applied. Valid values: shipmentDate (Default), shipmentValue"
                                    },
                                    "direction": {
                                        "type": "string",
                                        "description": "The direction of the sort. Valid values: asc, desc (Default)"
                                    }
                                },
                                "required": false
                            }
                        },
                        "response_body": {
                            "totalShipments": {
                                "type": "integer",
                                "description": "This attribute represents the total number of shipments matching the request criteria"
                            },
                            "shipments": {
                                "type": "array",
                                "description": "This attribute will contain a list of shipments that match the search criteria",
                                "items": {
                                    "type": "object",
                                    "Properties": {
                                        "identifier": {
                                            "type": "string",
                                            "description": "This is the unique identifier provided for every shipment"
                                        },
                                        "shipmentDate": {
                                            "type": "date",
                                            "description": "This attribute contains the date of the shipment (YYYY-MM-DD)"
                                        },
                                        "consigneeName": {
                                            "type": "string",
                                            "description": "This attribute contains the name of the consignee"
                                        },
                                        "consigneeCountry": {
                                            "type": "string",
                                            "description": "This attribute contains the name of the country of the consignee"
                                        },
                                        "shipperName": {
                                            "type": "string",
                                            "description": "This attribute contains the name of the shipper"
                                        },
                                        "shipperCountry": {
                                            "type": "string",
                                            "description": "This attribute contains the name of the country of the shipper"
                                        },
                                        "hsCode": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            },
                                            "description": "This attribute contains the HS codes of the shipment"
                                        },
                                        "productdescription": {
                                            "type": "string",
                                            "description": "This attribute contains the product description for the cargo or item"
                                        },
                                        "shipmentWeight": {
                                            "type": "float",
                                            "description": "This attribute contains the weight (kgs) of the shipment"
                                        },
                                        "shipmentValue": {
                                            "type": "float",
                                            "description": "This attribute specifies the shipment value (USD)"
                                        },
                                        "portOfLading": {
                                            "type": "string",
                                            "description": "This attribute contains the port of lading"
                                        },
                                        "portOfUnlading": {
                                            "type": "string",
                                            "description": "This attribute contains the port of unlading"
                                        },
                                        "modeOfTransportation": {
                                            "type": "string",
                                            "description": "This attribute specifies the mode of transport"
                                        }
                                    }
                                }
                            }
                        }
                    }
                ]
            },
            {
                "api_product_name": "Compliance APIs",
                "sub_data": [
                    {
                        "api_name": "landed cost api",
                        "api_endpoint": "{base_url}/v1/calculateCost",
                        "type": "POST",
                        "credit_rate": "",
                        "request_params": [
                            {
                                "key": "",
                                "data_type": "",
                                "required": "true/false",
                                "description": ""
                            }
                        ],
                        "default_curl": ""
                    },
                    {
                        "api_name": "controls",
                        "api_endpoint": "{base_url}/v1/controls",
                        "type": "POST",
                        "credit_rate": "",
                        "request_params": [
                            {
                                "key": "",
                                "data_type": "",
                                "required": "true/false",
                                "description": ""
                            }
                        ],
                        "default_curl": ""
                    }
                ]
            }
        ]
}


export let DUMMY_JSON = {
    "totalCompaniesCount": 38,
    "companies": [
        {
            "companyId": "61e1f1732e806cce399b46f0",
            "companyName": "bayerische motoren werke ag",
            "country": "germany",
            "nameMatchPercentage": 95.88,
            "totalShipmentCount": 1300606,
            "last_shipment_date": ""
        },
        {
            "companyId": "625b65faf63a7face3b16d29",
            "companyName": "bayerische motoren werke",
            "country": "united states",
            "nameMatchPercentage": 70.2,
            "totalShipmentCount": 8506,
            "last_shipment_date": ""
        },
        {
            "companyId": "63b2a5922af606c7b6c026b7",
            "companyName": "bayerische motoren werke",
            "country": "jamaica",
            "nameMatchPercentage": 70.0,
            "totalShipmentCount": 13,
            "last_shipment_date": ""
        },
        {
            "companyId": "62c82f87d6b8bfbd2191bb91",
            "companyName": "bayerische motoren werke ag",
            "country": "sweden",
            "nameMatchPercentage": 66.04,
            "totalShipmentCount": 6926,
            "last_shipment_date": ""
        },
        {
            "companyId": "62c830c3d6b8bfbd2191d60f",
            "companyName": "bayerische motoren werke ag",
            "country": "france",
            "nameMatchPercentage": 66.01,
            "totalShipmentCount": 5541,
            "last_shipment_date": ""
        },
        {
            "companyId": "62c830c0d6b8bfbd2191d5c7",
            "companyName": "bayerische motoren werke ag",
            "country": "brazil",
            "nameMatchPercentage": 65.93,
            "totalShipmentCount": 2207,
            "last_shipment_date": ""
        },
        {
            "companyId": "62c82f71d6b8bfbd2191b99f",
            "companyName": "bayerische motoren werke ag",
            "country": "switzerland",
            "nameMatchPercentage": 65.93,
            "totalShipmentCount": 1916,
            "last_shipment_date": ""
        },
        {
            "companyId": "62c83229d6b8bfbd2191fcf4",
            "companyName": "bayerische motoren werke ag",
            "country": "great britain",
            "nameMatchPercentage": 65.89,
            "totalShipmentCount": 505,
            "last_shipment_date": ""
        },
        {
            "companyId": "62c83229d6b8bfbd2191fcfd",
            "companyName": "bayerische motoren werke ag",
            "country": "japan",
            "nameMatchPercentage": 65.89,
            "totalShipmentCount": 468,
            "last_shipment_date": ""
        },
        {
            "companyId": "62c8317fd6b8bfbd2191ea82",
            "companyName": "bayerische motoren werke ag",
            "country": "china",
            "nameMatchPercentage": 65.89,
            "totalShipmentCount": 155,
            "last_shipment_date": ""
        }
    ]
}

export const DOMAIN_NAMES = [
    "mailinator.com",
    "business.com",
    "pwrwol.com",
    "mukdal.com",
    "in2reach.com",
    "velcar.pe",
    "mainator.com",
    "mailinatr.com",
    "0.mail.mujur.id",
    "089563.quest",
    "0fb36546-f7ed-4b97-aa02-b9156c1a31d2.rev3.cf",
    "101livemail.top",
    "bozztirex.us",
    "bozzcello.com",
    "gdriveme.id",
    "cloudmdrive.my.id",
    "karyakediri.oool.ooo",
    "vivaldigital.com",
    "10minutemailbox.com",
    "15qm-mail.red",
    "1maschio.site",
    "1resep.art",
    "1sydney.net",
    "24hschool.xyz",
    "2wslhost.com",
    "325designcentre.xyz",
    "327designexperts.xyz",
    "360yu.site",
    "gmail.com",
    "yahoo.com",
    "qq.com",
    "rediffmail.com",
    "aol.com",
    "outlook.com",
    "hotmail.com",
    "@protonmail.com",
    "@proton.me",
    "@gmail.com",
    "@outlook.com",
    "@hotmail.com",
    "@yahoo.com",
    "@myyahoo.com",
    "@zohomail.com",
    "@aol.com",
    "@icloud.com",
    "@me.com",
    "@mac.com",
]



export const PRODUCT_TYPE = {
    "intel": process.env.REACT_APP_API_EXPLORER_BASE_URL,
    'compliance': process.env.REACT_APP_COMPLIANCE_API_URL,
    'sanctions': process.env.REACT_APP_RPS_API_URL,
    'hsClassifier': process.env.REACT_APP_HS_CLASSIFIER_API_URL,
    'hsValidation': process.env.REACT_APP_HS_VALIDATION_API_URL,
    'finScreen': process.env.REACT_APP_FIN_SCREENER_URL,
}


export const SORTING_NAME = {
    asc: 'Ascending',
    desc: 'Descending'
}

export const ERROR_MSG = 'You have reached the maximum number of OTP requests allowed within an hour. Please wait briefly and try again.'

export const MONTH = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']


export const SIDEBAR_DATA = (props) => {
    return {
        // "Global Trade Data APIs": [
        //     {
        //         api_name: "Buyer Supplier Relationship Health API",
        //         isStatic: true,
        //         api_description: "The buyer supplier relationship health API enables risk underwriting by evaluating the trade between a buyer and supplier over a stipulated period of time, thus, enabling trade finance institutions to mitigate risk.",
        //         btnLink: process.env.REACT_APP_API_WEBSITE_URL + `/get-in-touch?type=Api Buyer Supplier Relationship Health&session=${props}`,
        //         imageSrc: `${CLOUDINARY_BASE_URL}/v1698405267/website/API%20Explorer/buyer-supplier_ozx4ni.png`,
        //         subCategories: [
        //             {
        //                 title: "Buyer/ Supplier Rank",
        //                 description: "Evaluate how a supplier ranks in a buyer's trade and vice versa. This helps gauge how integral these entities are to each other's business.",
        //                 imageSrc: `${CLOUDINARY_BASE_URL}/v1698390792/website/API%20Explorer/rank_cuhnlm.svg`,
        //             },
        //             {
        //                 title: "Continuous Evaluation",
        //                 description: "Periodic metrics enable trade finance institutions to establish continuity of trade relationships between buyers and suppliers.",
        //                 imageSrc: `${CLOUDINARY_BASE_URL}/v1698390791/website/API%20Explorer/evaluation_xiszd5.svg`,
        //             },
        //         ]
        //     },
        // ],
        // "Global Trade Compliance APIs": [
        //     {
        //         api_name: "Landed Cost Calculator API",
        //         isStatic: true,
        //         api_description: "It offers a wide range of content coverage, providing users with comprehensive and detailed information on duties and taxes for their transactions.",
        //         btnLink: process.env.REACT_APP_API_WEBSITE_URL + `/get-in-touch?type=Api Landed Cost Calculator API&session=${props}`,
        //         imageSrc: `${CLOUDINARY_BASE_URL}/v1698223065/website/API%20Explorer/LCC-api_eoyshd.png`,
        //         subCategories: [
        //             {
        //                 title: "Duty Comparison Across Multiple Countries",
        //                 description: "Users can effortlessly compare import duties across various exporting countries, allowing them to make informed decisions by understanding the actual differences in landed cost calculations.",
        //                 imageSrc: `${CLOUDINARY_BASE_URL}/v1698223160/website/API%20Explorer/duty_aqi0gm.svg`,
        //             },
        //             {
        //                 title: "Free Trade Agreement Calculations",
        //                 description: "Our platform empowers users to calculate landed costs by applying free trade agreements between nations, streamlining the import process.",
        //                 imageSrc: `${CLOUDINARY_BASE_URL}/v1698223161/website/API%20Explorer/calculations_v0bjw1.svg`,
        //             },
        //         ]
        //     },
        //     {
        //         api_name: "HS Code Validation API",
        //         isStatic: true,
        //         api_description: "This API facilitates to validate the HS code for your products along with additional compliance information",
        //         btnLink: process.env.REACT_APP_API_WEBSITE_URL + `/get-in-touch?type=Api HS Code Validation API&session=${props}`,
        //         imageSrc: `${CLOUDINARY_BASE_URL}/v1698223066/website/API%20Explorer/HS-api_wck7fs.png`,
        //         subCategories: [
        //             {
        //                 title: "Validate and know more about the HS code",
        //                 description: "Gain comprehensive insights into your HS code, including details such as VAT, import duties, and more for the specified code.",
        //                 imageSrc: `${CLOUDINARY_BASE_URL}/v1698223162/website/API%20Explorer/HS_code_qu9on4.svg`,
        //             },
        //             {
        //                 title: "Real time content updates",
        //                 description: "The content provided by government customs is consistently up-to-date and serves as the foundation for our validation results.",
        //                 imageSrc: `${CLOUDINARY_BASE_URL}/v1698223164/website/API%20Explorer/real_time_xmy6dw.svg`,
        //             },
        //         ]
        //     },
        //     {
        //         api_name: "Product Master API",
        //         isStatic: true,
        //         api_description: "Product Master API enables an innovative approach to end-to-end compliance management",
        //         btnLink: process.env.REACT_APP_API_WEBSITE_URL + `/get-in-touch?type=Api Product Master API&session=${props}`,
        //         imageSrc: `${CLOUDINARY_BASE_URL}/v1698223065/website/API%20Explorer/PM-api_pjjc7t.png`,
        //         subCategories: [
        //             {
        //                 title: "Easy integration with ERP",
        //                 description: "The API seamlessly scales alongside your ERP system, enabling real-time data synchronization to streamline compliance work.",
        //                 imageSrc: `${CLOUDINARY_BASE_URL}/v1698223163/website/API%20Explorer/integration_gfx5ix.svg`,
        //             },
        //             {
        //                 title: "Auto alerts for content updates",
        //                 description: "When the API is configured and integrated with your ERP, users receive automatic alerts for any changes in the content.",
        //                 imageSrc: `${CLOUDINARY_BASE_URL}/v1698223159/website/API%20Explorer/alert_zqelks.svg`,
        //             },
        //         ]
        //     }
        // ],
        // "Supply Chain Mapping & Risk Management APIs": [
        //     {
        //         api_name: "Nth Tier Supply Chain Mapping API",
        //         isStatic: true,
        //         api_description: "Explore Trademo’s Nth Tier Supply Chain API, which grants immediate access to AI-generated supply chain maps. With Trademo's API, you can effortlessly map supply chains to multiple tiers by just specifying your target company.",
        //         btnLink: process.env.REACT_APP_API_WEBSITE_URL + `/get-in-touch?type=Api Nth Tier Supply Chain API&session=${props}`,
        //         imageSrc: `${CLOUDINARY_BASE_URL}/v1698405267/website/API%20Explorer/nth-tier-sc_kl20iu.png`,
        //         subCategories: [
        //             {
        //                 title: "Data Coverage",
        //                 description: "Our database encompasses more than 12 million companies with more than 1 billion supply chain relationships, encompassing both publicly traded and privately held companies worldwide.",
        //                 imageSrc: `${CLOUDINARY_BASE_URL}/v1698390791/website/API%20Explorer/data-coverage_ialfdg.svg`,
        //             },
        //             {
        //                 title: "Filtering Supply Chains",
        //                 description: "Our APIs provide the user with the ability to filters based on HS Codes, time range and many other business criteria.",
        //                 imageSrc: `${CLOUDINARY_BASE_URL}/v1698390791/website/API%20Explorer/filter_cv4bqm.svg`,
        //             },
        //         ]
        //     },
        // ],
    }
}

export const CLOUDINARY_BASE_URL = "https://res.cloudinary.com/drzta9shk/image/upload/q_auto:best"
export const INTEL_CLOUDINARY_BASE_URL = "https://res.cloudinary.com/drzta9shk"
export const EMAIL_ERROR_MESSAGE ='Please enter a business email address'
export const API_DEV_URL = 'https://uat.trademo.com/trademo'


export const IGNORE_ERROR= [
    'Failed to fetch',
    'NetworkError when attempting to fetch resource.',
    'Cancelled',
    'Request failed with status code 401',
]


export const CUSTOM_INPUT_PILL='#f2f4f7'

